export default __webpack_public_path__ + "static/media/straw hat.e6de6506.png";